import { NSLoadingScreen, NSTable } from 'bricks';
import classNames from 'classnames';

interface IProFormaInputsTableProps {
    extractedValues?: { key: string; value: string; sheet: string; cell: string; cannotLocate: boolean; important: boolean }[];
    isExtracting?: boolean;
}

const ProFormaInputsTable = ({ extractedValues = [], isExtracting = false }: IProFormaInputsTableProps) => (
    <div className="w-50 d-flex flex-column p-3">
        <div className="mb-2">
            <strong>
                Pro forma inputs
                {extractedValues.length > 0 && ` (${extractedValues.length} fields)`}
            </strong>
            <div className="text-muted small">
                QA view — fields the agent attempts to extract from the uploaded Excel.
            </div>
        </div>

        {isExtracting ? (
            <div className="d-flex align-items-center justify-content-center flex-grow-1">
                <NSLoadingScreen shouldLoadAiLogo />
            </div>
        ) : (
            <NSTable bordered size="sm" className="NSTable--no-footer">
                <thead className="NSTable__thead">
                    <tr className="NSTable__thead__tr">
                        <th className="NSTable__thead__tr__th">Key</th>
                        <th className="NSTable__thead__tr__th">Status</th>
                        <th className="NSTable__thead__tr__th">Extracted value</th>
                        <th className="NSTable__thead__tr__th">Sheet</th>
                        <th className="NSTable__thead__tr__th">Cell</th>
                    </tr>
                </thead>
                <tbody className="NSTable__tbody">
                    {extractedValues.map(row => (
                        <tr
                            key={`${row.key}-${row.sheet}-${row.cell}`}
                            className={classNames("NSTable__tbody__tr NSTable__tbody__tr--hoverable", { "bg-success-lighten": row.important })}
                        >
                            <td className="NSTable__tbody__tr__td align-middle"><code>{row.key}</code></td>
                            <td
                                className={classNames("NSTable__tbody__tr__td align-middle", { "bg-danger-lighten": row.cannotLocate })}
                            >
                                {row.cannotLocate ? 'X' : <span className="text-muted">—</span>}
                            </td>
                            <td className="NSTable__tbody__tr__td align-middle">
                                {row.value ? <code>{row.value}</code> : <span className="text-muted">—</span>}
                            </td>
                            <td className="NSTable__tbody__tr__td align-middle">
                                {row.sheet ? row.sheet : <span className="text-muted">—</span>}
                            </td>
                            <td className="NSTable__tbody__tr__td align-middle">
                                {row.cell ? <code>{row.cell}</code> : <span className="text-muted">—</span>}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </NSTable>
        )}
    </div>
);

export default ProFormaInputsTable;
